import { gql } from "utils/urql";
import { forwardRef } from "react";
import ArticleInlineImageFigure from "./ArticleInlineImageFigure";
import { ArticleInlineImageFragment } from "types/api";

const ArticleInlineImage = forwardRef<HTMLElement, ArticleInlineImageFragment>(
  function ArticleInlineImage(props, ref) {
    return <ArticleInlineImageFigure ref={ref} {...props} />;
  }
);
ArticleInlineImage.fragment = gql`
  ${ArticleInlineImageFigure.fragment}
  fragment articleInlineImage on ArticleInlineImage {
    ...articleInlineImageFigure
    alignment
    clickthroughUrl
  }
`;

export default ArticleInlineImage;
